import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CampaignService } from "../../services/campaign.service";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { Campaign } from "../../models/campaign.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { HouseDataProvider } from "../../data-provider/house.dp";

let SelectPlanFormComponent = {
    selector: "vcSelectPlanForm",
    templateUrl:
        "/angular/components/campaign-plan/select-plan-form.component.html",
    bindings: {
        type: "=",
        conversionType: "=",
        charge: "=",
        planCallback: "&?",
        registerCallback: "&?",
        options: "=?",
        selectedInterval: "=?",
        selectedPlanName: "=?",
        creatingAccount: "=?",
        usedTrial: "=?",
    },
    controller: class SelectPlanFormController {
        // * bindings for typescript compiler *
        public type: any;
        public conversionType: any;
        public charge: any;
        public planCallback?: any;
        public registerCallback?: any;
        public options?: any;
        public selectedInterval?: any;
        public selectedPlanName?: any;
        public creatingAccount?: any;
        public usedTrial?: any;
        // ************************************

        private readonly notRecommendedPlans = [
            "Essentials",
            "Legacy",
            "Starter",
            "Standard",
            "Standard Plus",
        ];
        private readonly planColors = {
            Starter: "#eabcbf",
            Standard: "#69d8bd",
            StandardPlus: "#ffb37f",
            Pro: "#578aca",
            Premium: "#35347e",
        };

        private plans = [];
        private plan = null;
        private campaign: Campaign;
        private toggle;
        private recommendedMonthlyPlan = null;
        private recommendedYearlyPlan = null;
        private stage: string;
        private peopleCount: number;
        private recommendedPlan: any;

        private $scope: any;
        private $window: any;
        private __env: any;
        private $cookies: any;
        private $filter: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        private campaignService: CampaignService;
        private campaignDataProvider: CampaignDataProvider;
        private houseOccupantResource: HouseOccupantService;
        private subscriptionDataProvider: SubscriptionDataProvider;
        private houseDataProvider: HouseDataProvider;

        constructor(
            $scope: any,
            $window: any,
            __env: any,
            $cookies: any,
            $filter: any,
            CampaignService: CampaignService,
            CampaignDataProvider: CampaignDataProvider,
            HouseOccupantService: HouseOccupantService,
            SubscriptionDataProvider: SubscriptionDataProvider,
            HouseDataProvider: HouseDataProvider,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.__env = __env;
            this.$cookies = $cookies;
            this.$filter = $filter;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;

            this.campaignService = CampaignService;
            this.campaignDataProvider = CampaignDataProvider;
            this.houseOccupantResource = HouseOccupantService;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.houseDataProvider = HouseDataProvider;

            this.campaign = this.campaignDataProvider.getActiveCampaign();
            this.toggle = {
                flex: this.__env.product_name == "Ecanvasser" ? 70 : 35,
                gt_md: this.__env.product_name == "Ecanvasser" ? 40 : 20,
                yearly: this.__env.product_name == "Ecanvasser" ? true : false,
            };
        }

        $onInit() {
            if (!this.selectedInterval) {
                this.selectedInterval = "Monthly";
            }

            if (!this.selectedPlanName) {
                this.selectedPlanName = "Core 2.5k";
            }

            if (this.conversionType == "deleted") {
                this.stage = "campaignname";
            } else {
                this.stage = "plan";
            }
            if (this.options) {
                _.merge(this.options, {
                    resetPlan: () => {
                        this.plan = null;
                    },
                });
            }

            this.subscriptionDataProvider.getPlans().then((plans) => {
                this.plans = plans;

                angular.forEach(this.plans, (plan) => {
                    plan.color =
                        this.planColors[plan.cpname.replace(/\s+/g, "")];
                });

                this.peopleCount = 0;
                if (
                    this.conversionType != "deleted" &&
                    this.conversionType != "signup" &&
                    this.conversionType != "create"
                ) {
                    this.houseOccupantResource
                        .count()
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.peopleCount = parseInt(json.data);
                            }
                            this.houseDataProvider
                                .getCount()
                                .then((count: number) => {
                                    this.peopleCount =
                                        (count ?? 0) > this.peopleCount
                                            ? count
                                            : this.peopleCount;
                                    this.recommendedPlan =
                                        this.getRecommendedPlan();
                                });
                        });
                } else {
                    this.recommendedPlan = this.plans.filter((plan) => {
                        return (
                            plan.cpname.replace(/\s+/g, "") ==
                                this.selectedPlanName.replace(/\s+/g, "") &&
                            plan.cpinterval == this.selectedInterval
                        );
                    })[0];

                    this.recommendedYearlyPlan = this.plans.filter((plan) => {
                        return (
                            plan.cpname.replace(/\s+/g, "") ==
                                this.selectedPlanName.replace(/\s+/g, "") &&
                            plan.cpinterval == "Yearly"
                        );
                    })[0];

                    this.recommendedMonthlyPlan = this.plans.filter((plan) => {
                        return (
                            plan.cpname.replace(/\s+/g, "") ==
                                this.selectedPlanName.replace(/\s+/g, "") &&
                            plan.cpinterval == "Monthly"
                        );
                    })[0];

                    this.setPlan(this.recommendedPlan);
                }
            });
        }

        close(card, payment_method, promo_code) {
            //Check if user is here due to having a deleted campaign, if so, create a new campaign, else, upgrade
            if (this.conversionType == "signup") {
                if (this.registerCallback) {
                    this.registerCallback({
                        payment_method: payment_method,
                        card: card,
                        promo_code: promo_code,
                    });
                }
                return;
            }

            if (
                this.campaign.campaignstatusid == 3 ||
                this.campaign.permissionid == 7
            ) {
                this.createCampaign();
            } else {
                this.plan.conversiontype = this.conversionType;
                this.subscriptionDataProvider
                    .upgrade(this.campaign.campaignid, this.plan)
                    .then((campaign) => {
                        this.campaignDataProvider.setActiveCampaign(campaign);
                        this.toast.success("Account subscription upgraded");
                        if (this.type == "dialog") {
                            this.dialog.hide();
                        } else {
                            this.$window.location = "/#/";
                        }
                        this.$window.location.reload();
                    });
            }
        }

        createCampaign() {
            // ! Check if this method is needed. It wasn't declared in this class
            console.log("Testing if create campaign method needed");
        }

        getClassPlan(campaignplan): string {
            if (angular.isDefined(this.recommendedPlan)) {
                if (
                    campaignplan.cpid == this.campaign.cpid &&
                    this.conversionType != "create"
                ) {
                    if (campaignplan.cpname != this.recommendedPlan.cpname)
                        return "current-plan current-plan-style";
                    else return "rec-plan";
                } else if (campaignplan.cpname == this.recommendedPlan.cpname) {
                    return "rec-plan";
                }
            }
            return "";
        }

        getRecommendedPlan(): any {
            let max = 0;
            let foundPlan = null;
            angular.forEach(this.plans, function (plan) {
                if (!this.notRecommendedPlans.includes(plan.cpname)) {
                    max = this.planMax(plan.cpmax);
                    if (!foundPlan && max > 40000 && this.peopleCount < max) {
                        foundPlan = plan;
                    }
                }
            });
            return foundPlan;
        }

        planMax(number: string): number {
            number = number.replace(/,/g, "");
            return parseInt(number, 10);
        }

        openIntercomChat() {
            this.$window.Intercom(
                "showNewMessage",
                "Hi, I would like to change to Ecanvaasser Essentials please"
            );
        }

        setPlan(plan) {
            this.plan = plan;
            if (this.charge == false) {
                if (this.conversionType == "signup") {
                    this.subscriptionDataProvider
                        .setupIntentSignup()
                        .then((intent) => {
                            if (this.planCallback) {
                                this.planCallback({ plan: this.plan });
                            }
                            this.plan.intent = intent;
                        });
                } else {
                    this.subscriptionDataProvider
                        .setupIntentUpgrade()
                        .then((intent) => {
                            this.plan.intent = intent;
                        });
                }
            } else {
                this.subscriptionDataProvider
                    .paymentIntent(plan.cpid)
                    .then((intent) => {
                        this.plan.intent = intent;
                    });
            }
        }

        cancel() {
            this.dialog.hide();
        }

        openPlanSelectionDialog(plan, plans, event) {
            this.$window.scrollTo(0, 0);
            this.dialog
                .show({
                    component: "vc-select-plan-dialog",
                    targetEvent: event,
                    scope: this.$scope,
                    locals: {
                        conversionType: this.conversionType,
                        plan: plan,
                        plans: plans,
                        campaign: this.campaign,

                        planMax: this.planMax,
                        openIntercomChat: this.openIntercomChat,
                    },
                    size: "x-large",
                    style: "background: #f6f6f6",
                })
                .then((plan) => {
                    this.setPlan(plan);
                });
        }
    },
};

angular
    .module("campaignplan")
    .component(SelectPlanFormComponent.selector, SelectPlanFormComponent);
